


import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faPencilRuler, 
  faTools, 
  faShippingFast, 
  faHeadset,
  faPlayCircle,
  faTimes,
  faCheckCircle,
  faCogs,
  faBolt,
  faDollarSign,
  faLayerGroup,
  faTachometerAlt,
  faHandSparkles,
  faRulerCombined,
  faClipboardCheck,
  faExpand,
  faPlay,
  faSprayCanSparkles,
  faStar
} from "@fortawesome/free-solid-svg-icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./theme.css";
// import AlliclusiveVideo from "/assets/Images/ALL_INCLUSIVE_v2.mp4";

import vid6 from '../../Assesst/vid6.mp4';
import thm6 from '../../Assesst/629992239_17898564786381730_7476464499665088684_n.jpg';
import vid7 from '../../Assesst/vid7.mp4';
import thm7 from '../../Assesst/633802276_17899525947381730_5262136853547666250_n.jpg';
import vid8 from '../../Assesst/vid8.mp4';
import thm8 from '../../Assesst/Image-459.jpg';
import vid9 from '../../Assesst/vid9.mp4';
import thm9 from '../../Assesst/631467316_17899644711381730_1228051924609546819_n.jpg';
import thm10 from "../../Assesst/vid1.mp4"
import thm11 from "../../Assesst/thms8.png"


gsap.registerPlugin(ScrollTrigger);

const ServicesSection = () => {
  const Navigate = useNavigate();
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const videoRefs = useRef([]);
  const [activeVideo, setActiveVideo] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate cards on scroll
      cardsRef.current.forEach((card, index) => {
        gsap.fromTo(card,
          {
            y: 100,
            opacity: 0,
            scale: 0.8
          },
          {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 80%",
              end: "bottom 20%",
              toggleActions: "play none none reverse"
            },
            delay: index * 0.1
          }
        );
      });

      // Animate title
      gsap.fromTo(".services-title", 
        {
          y: 50,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".services-title",
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const services = [
    {
      icon: faStar,
      title: "New Cabinet Style",
      videoUrl: thm10,
      videoType: "video/mp4",
      features: ["Transform Your Space", "Shaker • Petite • Raised Center Styles", "Variety of cabinets for every taste", "290+ colors to match your vision"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm11, // Add thumbnail if available
    },
    {
      icon: faClipboardCheck,
      title: "All Inclusive",
      videoUrl: vid9,
      videoType: "video/mp4",
      features: ["Complete Project Management", "No Hidden Costs", "End-to-End Solution", "Quality Assurance"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm9, // Add thumbnail if available
    },
    {
      icon: faLayerGroup,
      title: "Premium Materials",
      videoUrl: vid8,
      videoType: "video/mp4",
      features: ["High-Grade Materials", "Durable Finishes", "Eco-Friendly Options", "Industry Best Quality"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm8,
    },
    {
      icon: faRulerCombined,
      title: "Full Custom",
      videoUrl: vid7,
      videoType: "video/mp4",
      features: ["Tailored Designs", "3D Visualization", "Personalized Planning", "Flexible Options"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm7,
    },
    {
      icon: faBolt,
      title: "Problem & Solution",
      videoUrl: vid6,
      videoType: "video/mp4",
      features: ["All materials and Labor in one place", "Optimized space- everything is fully custom", "We remove coordination stress with multiple suppliers", " ⁠Unbeatable price- Guaranteed!"],
      gradient: "var(--color-primary-500)",
      thumbnail: thm6,
    }
  ];

  const addToCardsRef = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };

  const addToVideoRefs = (el, index) => {
    if (el) {
      videoRefs.current[index] = el;
    }
  };

  const handleVideoClick = (videoUrl, index, e) => {
    e.stopPropagation();
    setActiveVideo({ url: videoUrl, index });
  };

  const handleCloseFullscreen = () => {
    setActiveVideo(null);
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  // Convert gradient classes to inline styles
  const getGradientStyle = (gradientClass) => {
    switch(gradientClass) {
      case "from-purple-500 to-pink-500":
        return { background: "linear-gradient(135deg, #8b5cf6, #ec4899)" };
      case "from-blue-500 to-cyan-500":
        return { background: "linear-gradient(135deg, #3b82f6, #06b6d4)" };
      case "from-green-500 to-emerald-500":
        return { background: "linear-gradient(135deg, #10b981, #059669)" };
      case "from-orange-500 to-amber-500":
        return { background: "var(--gradient-primary)" };
      default:
        return { background: "var(--gradient-primary)" };
    }
  };

  // Get gradient color for small dots
  const getGradientColor = (gradientClass) => {
    switch(gradientClass) {
      case "from-purple-500 to-pink-500":
        return "#8b5cf6";
      case "from-blue-500 to-cyan-500":
        return "#3b82f6";
      case "from-green-500 to-emerald-500":
        return "#10b981";
      case "from-orange-500 to-amber-500":
        return "var(--color-primary-500)";
      default:
        return "var(--color-primary-500)";
    }
  };

  return (
    <>
      <section
        ref={sectionRef}
        className="py-20 relative overflow-hidden"
        aria-labelledby="services-heading"
        style={{
          background: "var(--gradient-bg)",
        }}
      >
        {/* Background Decorations */}
        <div 
          className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40"
          style={{
            backgroundColor: "var(--color-primary-100)",
          }}
        ></div>
        <div 
          className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-60"
          style={{
            backgroundColor: "var(--color-secondary-50)",
          }}
        ></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Section Header */}
          <header className="text-center mb-16">
            <h2
              id="services-heading"
              className="bell-mt-primary services-title text-4xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent mb-6"
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
              }}
            >
              Why Choose Laminance?
            </h2>
            
            <motion.p 
              className="text-xl max-w-3xl mx-auto leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              style={{
                color: "var(--color-gray-600)",
              }}
            >
              Experience unparalleled quality and service with our comprehensive kitchen solutions
            </motion.p>
          </header>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" role="list">
            {services.map((service, index) => (
              <motion.article
                key={index}
                ref={addToCardsRef}
                className="group relative rounded-3xl hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer"
                whileHover={{ y: -10, scale: 1.02 }}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                onClick={(e) => handleVideoClick(service.videoUrl, index, e)}
                role="listitem"
                aria-labelledby={`service${index + 1}-title`}
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: "var(--shadow-medium)",
                  border: "1px solid var(--border-light)",
                }}
              >
                {/* Background Gradient */}
                <div 
                  className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500"
                  style={getGradientStyle(service.gradient)}
                ></div>
                
                <div className="relative">
                  {/* Video Container - Static video showing first frame */}
                  <div className="relative w-full aspect-video bg-gray-900 overflow-hidden">
                    <video
                      ref={(el) => addToVideoRefs(el, index)}
                      id={`service-video-${index}`}
                      className="w-full h-full object-cover"
                      muted
                      playsInline
                      preload="metadata" // Load only metadata to show first frame
                      poster={service.thumbnail} // Show thumbnail if available
                      onClick={(e) => e.stopPropagation()}
                    >
                      <source src={service.videoUrl} type={service.videoType} />
                      Your browser does not support the video tag.
                    </video>

                    {/* Static overlay to show service title on video */}
                   

                    {/* Hover Overlay - Only shows on hover */}
                    <motion.div 
                      className="absolute inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: hoveredIndex === index ? 1 : 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <motion.div
                        className="w-16 h-16 rounded-full flex items-center justify-center bg-var(--color-primary-500) shadow-xl border-4 border-white/80"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={(e) => handleVideoClick(service.videoUrl, index, e)}
                      >
                        <FontAwesomeIcon
                          icon={faPlay}
                          style={{
                            color: "var(--color-white)",
                            fontSize: "1.5rem",
                            marginLeft: "6px"
                          }}
                        />
                      </motion.div>
                    </motion.div>
                  </div>

                  {/* Content Section */}
                  <div className="p-6 text-center">
                    {/* Icon Container - Always visible */}
                    <motion.div 
                      className="relative inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 shadow-lg -mt-12 border-4 border-white"
                      style={getGradientStyle(service.gradient)}
                    >
                      <FontAwesomeIcon
                        icon={service.icon}
                        style={{
                          color: "var(--color-white)",
                          fontSize: "1.5rem",
                        }}
                      />
                    </motion.div>

                    {/* Service Title - Already shown on video, but keeping for consistency */}
                    <h3
                      id={`service${index + 1}-title`}
                      className="bell-mt-primary text-xl font-bold mb-4 transition-colors duration-300"
                      style={{
                        color: "var(--color-gray-600)",
                      }}
                    >
                      {service.title}
                    </h3>

                    {/* Features List */}
                    <div className="space-y-2">
                      {service.features.map((feature, featureIndex) => (
                        <motion.div
                          key={featureIndex}
                          className="flex items-center gap-2 text-xs transition-colors duration-300"
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ delay: featureIndex * 0.1 + 0.3 }}
                          style={{
                            color: "var(--color-gray-600)",
                          }}
                        >
                          <div className="flex-shrink-0">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              style={{
                                color: getGradientColor(service.gradient),
                                fontSize: "0.75rem",
                              }}
                            />
                          </div>
                          <span className="text-left">{feature}</span>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Hover Border Effect */}
                <div 
                  className="absolute inset-0 rounded-3xl border-2 border-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"
                  style={getGradientStyle(service.gradient)}
                >
                  <div 
                    className="absolute inset-[2px] rounded-3xl -z-10"
                    style={{
                      backgroundColor: "var(--color-white)",
                    }}
                  ></div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* Full Screen Video Modal */}
      <AnimatePresence>
        {activeVideo && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleCloseFullscreen}
          >
            <motion.div
              className="relative w-full max-w-6xl bg-black rounded-2xl overflow-hidden"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", damping: 25 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                aspectRatio: "16/9",
              }}
            >
              {/* Close Button */}
              <motion.button
                className="absolute top-4 right-4 z-20 w-12 h-12 rounded-full flex items-center justify-center bg-black/60 backdrop-blur-sm hover:bg-black/80 transition-colors border border-white/20"
                onClick={handleCloseFullscreen}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FontAwesomeIcon 
                  icon={faTimes} 
                  style={{ color: "var(--color-white)", fontSize: "1.25rem" }}
                />
              </motion.button>

              {/* Video Player */}
              <div className="relative w-full h-full bg-black">
                <video
                  className="w-full h-full object-contain"
                  controls
                  autoPlay
                  playsInline
                  controlsList="nodownload"
                >
                  <source 
                    src={activeVideo.url} 
                    type={services.find(s => s.videoUrl === activeVideo.url)?.videoType || "video/mp4"} 
                  />
                  Your browser does not support the video tag.
                </video>
              </div>

              {/* Hint text */}
              
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ServicesSection;